import React from 'react'
import Message from '../Message'
import { ModalOverlay, ModalContent } from './Modal.styled'
import { Body2, H4 } from '../Typo'
import { FullWidthButton } from '../../Map/components/LegendButton'

interface ModalProps {
  title: string | React.JSX.Element
  text: string | React.JSX.Element
  isOpen: boolean
  onClose: () => void
}

export const MapModal: React.FC<ModalProps> = ({
  title,
  text,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null

  return (
    <ModalOverlay>
      <ModalContent>
        <H4 $mb={4}>{title}</H4>
        <Body2 $mb={4}>{text}</Body2>
        <FullWidthButton onClick={onClose}>
          <Message id="BUTTON_UNDERSTOOD" />
        </FullWidthButton>
      </ModalContent>
    </ModalOverlay>
  )
}
